import { useEffect, useState } from 'react';

import { IProdutoVmp } from '../../modules/types/Medsus';
import { getAllProdutoVmp } from '../medsus/medsusItemService';

// services/cache/obmVmpMemoryCache.ts

let obmVmpCache: IProdutoVmp[] | null = null;

export function getObmVmpMemoryCache() {
  return obmVmpCache;
}

export function setObmVmpMemoryCache(data: IProdutoVmp[]) {
  obmVmpCache = data;
}

export function clearObmVmpMemoryCache() {
  obmVmpCache = null;
}

export function useProdutoVmpCache() {
  const [data, setData] = useState<IProdutoVmp[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const cached = getObmVmpMemoryCache();
    if (cached) {
      setData(cached);
      return;
    }

    setLoading(true);
    getAllProdutoVmp()
      .then((result) => {
        setData(result);
        setObmVmpMemoryCache(result);
      })
      .finally(() => setLoading(false));
  }, []);

  return { data, loading };
}
